/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Schema fields for formily
 */
// TODO
import { useMemo } from 'react';
import _ from 'lodash';
import {
	ArrayCards,
	ArrayTable,
	Editable,
	FormCollapse,
	FormGrid,
	FormItem,
	Input as AntdInput,
	NumberPicker as InputNumber,
	Space,
	Switch,
	Upload,
	Password,
	Checkbox,
	ArrayItems,
	Radio,
	Select,
} from '@formily/antd-v5';
import { AutoComplete, Button, Card, Row, Statistic, Tag, Tooltip, TooltipProps, Typography } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import { connect, createSchemaField, mapReadPretty } from '@formily/react';
import { DatePicker as CustomDatePicker, MultiSelect, RangePicker, TimePicker } from 'lib/antd';
import {
	ProviderNpis,
	SelectedPayers,
	ServiceTypeDropdown,
	UserRoles,
	CustomCheckbox,
	LogoUpload,
	OrganizationSettingsCard,
	CustomPasswordValidator,
	ServiceLinesTable,
	RevenueCodeTable,
	AdditionalLineItemTable,
	ClaimAdjudicationTable,
	InsuredTable,
	PayerTable,
	QualTable,
	TreatmentAuthorizationTable,
	CodeField,
	CustomLineAdjustmentsRenderer,
	RemarkCode,
	CloudflareUploadField,
	GuarantorSelect,
	CustomArrayTable,
	OutstandingPRTag,
	FormFlex,
	PatientCoveragePayers,
} from './customComponents';
import AddOptionalFieldButton from 'components/eligibility/batchUpload/dataProcessing/headerMapping/AddOptionalFieldButton';
import RemovableFormItem from 'components/eligibility/batchUpload/dataProcessing/headerMapping/RemovableFormItem';
import { EMPTY_VALUE } from '@veritable/common/constants';

export interface TooltipWrapperProps {
	component: string;
	tooltipText: string | string[];
	tooltipPlacement: TooltipProps['placement'];
	onChange?: (value: AnyType) => void;
	value?: AnyType;
	[key: string]: AnyType;
}

const DatePicker = connect(
	CustomDatePicker,
	mapReadPretty(({ value }) => <Typography.Text>{value || EMPTY_VALUE}</Typography.Text>),
);

const NumberPicker = connect(
	InputNumber,
	mapReadPretty(({ value, showEmptyValue = true }) => (
		<Typography.Text>{value || (showEmptyValue ? EMPTY_VALUE : value)}</Typography.Text>
	)),
);

const Input = connect(
	AntdInput,
	mapReadPretty(({ value, showEmptyValue = true, readPrettyStyle, readPrettyClassName }) => (
		<Typography.Text className={readPrettyClassName} style={readPrettyStyle}>
			{value || (showEmptyValue ? EMPTY_VALUE : value)}
		</Typography.Text>
	)),
);

const formComponents = {
	AutoComplete,
	Row,
	ArrayTable,
	Editable,
	ArrayCards,
	FormGrid,
	FormItem,
	Input,
	NumberPicker,
	Select,
	Button,
	Space,
	Switch,
	Upload,
	FormCollapse,
	Password,
	Checkbox,
	Card,
	Tag,
	UserRoles,
	// FieldsetCard,
	DatePicker,
	MultiSelect,
	ProviderNpis,
	SelectedPayers,
	// IdentityVerification,
	CustomCheckbox,
	LogoUpload,
	ArrayItems,
	Radio,
	// NpiValidatorField,
	ServiceTypeDropdown,
	Tooltip,
	OrganizationSettingsCard,
	// BatchSupportNote,
	CustomPasswordValidator,
	ServiceLinesTable,
	QualTable,
	TreatmentAuthorizationTable,
	InsuredTable,
	PayerTable,
	RevenueCodeTable,
	AdditionalLineItemTable,
	ClaimAdjudicationTable,
	RangePicker,
	CodeField,
	CustomLineAdjustmentsRenderer,
	RemarkCode,
	TimePicker,
	Statistic,
	CloudflareUploadField,
	GuarantorSelect,
	CustomArrayTable,
	OutstandingPRTag,
	FormFlex,
	WarningFilled,
	Typography,
	PatientCoveragePayers,
};

// tooltip text
const prepareTooltipText = (tooltipText: string | string[]): string | React.ReactNode => {
	if (_.isArray(tooltipText)) {
		return (
			<ul style={{ margin: 0, paddingInlineStart: 12 }}>
				{_.map(tooltipText, (text, index) => (
					<li key={index}>{text}</li>
				))}
			</ul>
		);
	}
	return tooltipText;
};

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ component, tooltipText, tooltipPlacement, ...rest }) => {
	const Component = useMemo(() => _.get(formComponents, component), [component]);
	if (Component) {
		return (
			<Tooltip
				title={prepareTooltipText(tooltipText)}
				placement={tooltipPlacement || 'right'}
				overlayInnerStyle={{ width: 'max-content', maxWidth: 350 }}
			>
				<span>
					<Component {...rest} />
				</span>
			</Tooltip>
		);
	}
};

const SchemaField = createSchemaField({
	components: {
		...formComponents,
		TooltipWrapper,
		AddOptionalFieldButton,
		RemovableFormItem,
	},
});
export default SchemaField;
